import { render, staticRenderFns } from "./feeDetail.vue?vue&type=template&id=5acb9646&scoped=true&"
import script from "./feeDetail.vue?vue&type=script&lang=js&"
export * from "./feeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acb9646",
  null
  
)

export default component.exports